<template>
  <!-- eslint-disable vue/no-v-html -->
  <div class="text-content" v-html="newContent" />
  <!-- eslint-enable vue/no-v-html -->
</template>

<script>
import config from "../../nuxt.config";
export default {
  props: {
    content: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      newContent: null,
    };
  },
  watch: {
    content() {
      this.createContent();
    },
  },
  mounted() {
    this.createContent();
  },
  methods: {
    createContent() {
      if (this.content) {
        const el = document.createElement("html");
        el.innerHTML = this.content;
        const images = el.querySelectorAll("img");
        const links = el.querySelectorAll("a");
        images.forEach((item) => {
          const src = item.getAttribute("src");
          const startStr = src.substring(0, 4);
          if (startStr !== "http")
            item.setAttribute("src", config.env.BASE_URL + src);
        });
        links.forEach((item) => {
          item.setAttribute("target", "_blank");
        });
        const body = el.querySelector("body");
        this.newContent = body.innerHTML;
      }
    },
  },
};
</script>

<style lang="scss">
.text-content {
  ul li {
    margin-bottom: 1.5rem;
    position: relative;
    padding-left: 3rem;

    &::after {
      content: "";
      display: block;
      width: 1rem;
      height: 1rem;
      border-radius: 50%;
      background: #718793;
      position: absolute;
      top: calc(1.6rem / 2);
      left: 0.5rem;
    }
  }
}
</style>
